module.exports = __webpack_public_path__ + "img/icon_photovoltaic_on.cfdfe050.png";